import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { takeUntil, tap } from 'rxjs';

import { LoaderComponent } from '@component/loader/loader.component';
import { NotificationsSidebarComponent } from '@component/notifications-sidebar/notifications-sidebar.component';
import { UnsubscribeDirective } from '@component/shared/unsubscribe.directive';
import { EmergencyService } from '@service/emergency.service';
import { WebsocketService } from '@service/websocket.service';
import { ApiMessageSeverity } from '@type/message.type';

import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ToastModule,
    LoaderComponent,
    NavbarComponent,
    ConfirmDialog,
    NotificationsSidebarComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends UnsubscribeDirective {
  private readonly emergencyService = inject(EmergencyService);
  private readonly messageService = inject(MessageService);
  private readonly websocketService = inject(WebsocketService);

  constructor() {
    super();

    this.websocketService.filterMessages({
      type: 'resource.event',
      payload: { resource_type: 'emergency' },
    }).pipe(
      takeUntil(this.destroy),
      tap(() => {
        this.messageService.add({
          severity: ApiMessageSeverity.warn,
          summary: 'New emergency',
          detail: 'You have a new emergency - go to page for more details',
          life: 5000,
        });
      }),
      tap(() => this.emergencyService.triggerRefresh()),
    )
      .subscribe();
  }

}
